// @flow

import { GeoJsonEditMode } from './geojson-edit-mode.js';

export class ViewMode extends GeoJsonEditMode {}
